module.exports = __webpack_public_path__ + "static/IMG-1-8c17590061367ccd98494aeec8550e04.jpg";